import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { inject } from "vue";

export function useAiAutoLoginAction() {
  const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;

  const lockProperty = async (propertyId: number, lock: boolean) => {
    await apiClient.httpPostVoid(`database/properties/${propertyId}/lock`, {
      lock: lock,
    });
  };

  return {
    lockProperty,
  };
}
